module.exports = __webpack_public_path__ + "img/1.0d06a0a4.png";